// @ts-nocheck
import { SEGMENT_KEY_SCALERS } from '@scale/frontend-lib/constants';
import createAnalyticsWrapper from '@scale/frontend-lib/analytics/create-analytics-wrapper';
import createNextIntegration from '@scale/frontend-lib/analytics/create-next-integration';

export const analytics = createAnalyticsWrapper(SEGMENT_KEY_SCALERS);
export const nextIntegration = createNextIntegration(analytics);
